import React, { useCallback } from 'react';
import { Icon, Button } from '@pwc/pwc-deals-ui';
import PropTypes from 'prop-types';
import './ToggleGridList.scss';

const ICON_SIZE = 24;

const ToggleGridList = ({ viewGrid, onClick }) => {
  const getButtons = useCallback(
    () => [
      {
        testId: 'grid-view-toggle',
        iconName: 'grid-view',
        iconClass: `${viewGrid ? 'fill' : 'outline'} icon-orange-theme`,
      },
      {
        testId: 'list-view-toggle',
        iconName: 'list-view',
        iconClass: `${viewGrid ? 'outline' : 'fill'} icon-orange-theme`,
      },
    ],
    [viewGrid]
  );
  const buttons = getButtons(viewGrid);

  return (
    <div className="toggle-container" data-testid="grid-list-toggle">
      {buttons.map((button) => {
        return (
          <Button
            type="button"
            key={`toggle-button-${button.testId}`}
            className="button-toggle button-no-appearance"
            data-testid={button.testId}
            onClick={() => {
              if (
                (button.iconName === 'grid-view' && !viewGrid) ||
                (button.iconName === 'list-view' && viewGrid)
              ) {
                onClick();
              }
            }}
          >
            <Icon
              name={button.iconName}
              width={ICON_SIZE}
              className={button.iconClass}
            />
          </Button>
        );
      })}
    </div>
  );
};

ToggleGridList.propTypes = {
  viewGrid: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default ToggleGridList;
